(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('applicationService', applicationService);

    /* @ngInject */
    function applicationService($http, $q, exception, logger, coreService, moment, config, $odataresource, $odata) {
        var service = {
            getDefaultApplication: getDefaultApplication,
            getApplicationFields: getApplicationFields,
            getApplicationOverviewFields: getApplicationOverviewFields,
            getApplications: getApplications,
            getApplicationTypes: getApplicationTypes,
            getApplication: getApplication,
            getApplicationsForLogOut: getApplicationsForLogOut,
            searchEmail: searchEmail,
            saveApplication: saveApplication,
            getModalOptions: getModalOptions,
            setActive: setActive,
            getNotAssignedApplications: getNotAssignedApplications,
            getODataResource: getODataResource,
            getTableConfig: getTableConfig,
            dropDownApplicationTypes: dropDownApplicationTypes,
            getAllApplications: getAllApplications,
            getUserApplicationsWithAllRoles: getUserApplicationsWithAllRoles,
            getApplicationByShortName: getApplicationByShortName
        };

        activate();

        return service;

        function activate() {
        }

        function getTableConfig() {
            var tableConfig = {
                columns: [
                    {
                        id: 'ApplicationTypeId',
                        displayName: 'Type',
                        ODataKey: 'ApplicationTypeId',
                        type: 'dropDown',
                        DropDown: { parent: 'ApplicationType', key: 'ApplicationTypeName' },
                        options: dropDownApplicationTypes()
                    },
                    {
                        id: 'ApplicationName',
                        displayName: 'Name',
                        ODataKey: 'ApplicationName',
                        type: 'match',
                        tooltip: {
                            placement: 'right',
                            text: function (row) {
                                var roles = '';
                                angular.forEach(row.Roles, function (role) {
                                    roles = roles + ', ' + role.RoleName;
                                });

                                roles = roles.slice(2);
                                return roles && 'Roles: ' + roles;
                            }
                        }
                    },
                    {
                        id: 'ShortName',
                        displayName: 'Short Name',
                        ODataKey: 'ShortName',
                        type: 'match'
                    },
                    {
                        id: 'IsLegacy',
                        displayName: 'Is Legacy',
                        ODataKey: 'IsLegacy', type: 'bool'
                    },
                    {
                        id: 'ShortDescription',
                        displayName: 'Short Description',
                        ODataKey: 'ShortDescription',
                        type: 'match'
                    },
                    {
                        id: 'DateUpdated',
                        displayName: 'Date Updated',
                        ODataKey: 'DateUpdated',
                        type: 'date'
                    },
                    {
                        id: 'IsActive',
                        displayName: 'Is Active',
                        ODataKey: 'IsActive',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'Active'
                            },
                            off: {
                                className: 'danger',
                                display: 'Inactive'
                            }
                        }
                    }
                ],
                actions: []
            };
            return tableConfig;
        }

        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/Applications',
                {},
                {},
                {
                    odatakey: 'ApplicationID',
                    isodatav4: true
                });
        }

        function getDefaultApplication() {
            return {
                ApplicationId: 0,
                ApplicationTypeId: 0,
                ApplicationType: '',
                IsActive: true,
                ApplicationName: '',
                ShortName: '',
                IsLegacy: false,
                LogOutURL: '',
                PortalURL: '',
                ShortDescription: '',
                LongDescription: '',
                Icon: '',
                IsMultifactorActive: true
            };
        }

        function getApplicationFields() {
            var applicationFields = [
                {
                    className: '',
                    fieldGroup: [
                      {
                          className: 'col-xs-6',
                          key: 'ApplicationName',
                          type: 'input',
                          templateOptions: {
                              type: 'text',
                              label: 'Application Name',
                              placeholder: 'Enter Application Name',
                              required: true,
                              maxlength: 255
                          }
                      },
                      {
                          className: 'col-xs-6',
                          key: 'ShortName',
                          type: 'input',
                          templateOptions: {
                              type: 'text',
                              label: 'Short Name',
                              placeholder: 'Enter Short Name',
                              required: true,
                              maxlength: 5
                          }
                      }
                    ]
                },
                {
                    className: '',
                    fieldGroup: [
                      {
                          className: 'col-xs-12',
                          key: 'LongDescription',
                          type: 'textarea',
                          templateOptions: {
                              label: 'Application Long Description',
                              placeholder: 'Enter Application Long Description',
                              required: true,
                              maxlength: 255,
                              rows: 4
                          }
                      }
                    ]
                },
                {
                    className: '',
                    fieldGroup: [
                      {
                          className: 'col-xs-12',
                          key: 'ShortDescription',
                          type: 'input',
                          templateOptions: {
                              type: 'text',
                              label: 'Application Short Description',
                              placeholder: 'Enter Application Short Description',
                              required: true,
                              maxlength: 50
                          }
                      }
                    ]
                },
                {
                    className: '',
                    fieldGroup: [
                      {
                          className: 'col-xs-6',
                          key: 'Icon',
                          type: 'input',
                          templateOptions: {
                              type: 'url',
                              label: 'Application Icon Path',
                              placeholder: 'Enter Application Icon Path',
                              required: true,
                              maxlength: 255
                          }
                      },
                      {
                          className: 'col-xs-6',
                          key: 'ApplicationTypeId',
                          type: 'ui-select-single',
                          defaultValue: 2,
                          templateOptions: {
                              optionsAttr: 'bs-options',
                              label: 'Application Type',
                              ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                              options: getApplicationTypes(),
                              valueProp: 'ApplicationTypeId',
                              labelProp: 'ApplicationTypeName',
                              placeholder: 'Select Application Type'
                          },
                          controller: /* @ngInject */ function ($scope) {
                              $scope.$watch('model.ApplicationTypeId', function (newValue, oldValue, theScope) {
                                  $scope.model['ApplicationType'] = theScope.to.options[newValue - 1];
                              });

                          }
                      }
                    ]
                },
                {
                    className: '',
                    fieldGroup: [
                      {
                          className: 'col-xs-6',
                          key: 'LogOutURL',
                          type: 'input',
                          templateOptions: {
                              type: 'url',
                              label: 'Log Out URL',
                              placeholder: 'Enter Application Log Out URL',
                              required: true
                          }
                      },
                      {
                          className: 'col-xs-6',
                          key: 'PortalURL',
                          type: 'input',
                          templateOptions: {
                              type: 'url',
                              label: 'Portal URL',
                              placeholder: 'Enter Application Portal URL',
                              required: true
                          }
                      }
                    ]
                },
                {
                    className: '',
                    fieldGroup: [
                      {
                          className: 'col-xs-6',
                          key: 'IsLegacy',
                          type: 'checkbox',
                          templateOptions: {
                              label: 'Is Legacy Application'
                          }
                      },
                      {
                          className: 'col-xs-6',
                          key: 'IsActive',
                          type: 'checkbox',
                          templateOptions: {
                              label: 'Is Application Active'
                          }
                      }
                    ]
                },
                {
                    className: '',
                    fieldGroup: [
                      {
                          className: 'col-xs-12',
                          key: 'DateCreated',
                          type: 'datepicker',
                          defaultValue: moment().toDate(),
                          ngModelAttrs: {
                              customAttrVal: {
                                  attribute: 'disabled'
                              }
                          },
                          templateOptions: {
                              label: 'Date Created',
                              type: 'text',
                              datepickerPopup: 'dd-MMMM-yyyy',
                              disabled: true
                          }
                      }
                    ]
                }
            ];
            return applicationFields;
        }


        function getApplicationOverviewFields() {
            var applicationFields = [
                {
                    className: '',
                    fieldGroup: [
                      {
                          className: 'col-xs-6',
                          key: 'ApplicationName',
                          type: 'input',
                          templateOptions: {
                              type: 'text',
                              label: 'Application Name',
                              placeholder: 'Enter Application Name',
                              required: true,
                              maxlength: 255,
                              disabled: true
                          }
                      }
                    ]
                },
                {
                    className: '',
                    fieldGroup: [
                      {
                          className: 'col-xs-12',
                          key: 'LongDescription',
                          type: 'textarea',
                          templateOptions: {
                              label: 'Application Long Description',
                              placeholder: 'Enter Application Long Description',
                              required: true,
                              maxlength: 255,
                              rows: 4,
                              disabled: true
                          }
                      }
                    ]
                },
                {
                    className: '',
                    fieldGroup: [
                      {
                          className: 'col-xs-6',
                          key: 'DateCreated',
                          type: 'datepicker',
                          defaultValue: moment().toDate(),
                          ngModelAttrs: {
                              customAttrVal: {
                                  attribute: 'disabled'
                              }
                          },
                          templateOptions: {
                              label: 'Date Created',
                              type: 'text',
                              datepickerPopup: 'dd-MMMM-yyyy',
                              disabled: true
                          }
                      },
                      {
                          className: 'col-xs-6',
                          key: 'DateUpdated',
                          type: 'datepicker',
                          ngModelAttrs: {
                              customAttrVal: {
                                  attribute: 'disabled'
                              }
                          },
                          templateOptions: {
                              label: 'Date Updated',
                              type: 'text',
                              datepickerPopup: 'dd-MMMM-yyyy',
                              disabled: true
                          }
                      }
                    ]
                }
            ];
            return applicationFields;
        }

        function getApplications(tableState) {
            var query = service.getODataResource().odata();

            if (!!tableState) {
                coreService.processODataFilters(query, tableState.search.predicateObject, getTableConfig().columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ? tableState.sort : {
                predicate: 'ApplicationName', reverse: false
            };
            coreService.processODataSort(query, tableState.sort);

            return query
                .expand('ApplicationType')
                .expand('Roles')
                .withInlineCount()
                .query()
                .$promise;
        }


        function getAllApplications() {
            var query = service.getODataResource().odata();
                        
            return query
                .expand('Roles')               
                .query()
                .$promise;
        }


        function getUserApplicationsWithAllRoles(userId) {
            var query = service.getODataResource().odata();

            return query
                .expand('Roles') 
                .expand('UserApplicationTies')
                .filter(new $odata.Func('any', 'UserApplicationTies', 'r', new $odata.Predicate('r/UserId', userId)))
                .query()
                .$promise;
        }

        function getApplicationTypes() {
            return [
                {
                    ApplicationTypeId: 1,
                    ApplicationTypeName: 'API'
                },
                {
                    ApplicationTypeId: 2,
                    ApplicationTypeName: 'Site'
                },
                {
                    ApplicationTypeId: 3,
                    ApplicationTypeName: 'Mobile'
                }
            ];
        }

        function getApplication(applicationID) {
            return getODataResource()
                .odata()
                .get(applicationID)
                .$promise;
        }

        function searchEmail(Email) {
            var url = coreService.updateQueryStringParameter('application/EmailExists', 'Email', Email);
            return coreService.httpAccountsGet(url);
        }

        function saveApplication(application) {
            return coreService.httpAccountsPost('application', application);
        }

        function getModalOptions() {
            return {
                animation: true,
                templateUrl: 'app/application/dashboard/modal/application.modal.html',
                controllerAs: 'vm'
            };
        }

        function setActive(application) {
            var data = {
                IsActive: application.IsActive
            };
            var url = 'application/';
            url = url + encodeURIComponent(application.ApplicationId);
            url = url + '/SetActive';
            return coreService.httpAccountsPost(url, data);
        }

        function getNotAssignedApplications(userID) {
            var url = 'Application/';
            url = url + encodeURIComponent(userID);
            url = url + '/NotAssigned';
            return coreService.httpAccountsGet(url);
        }

        function dropDownApplicationTypes() {
            return getApplicationTypes().map(function (applicationType) {
                return {
                    value: applicationType.ApplicationTypeId,
                    name: applicationType.ApplicationTypeName
                };
            });
        }

        function getApplicationsForLogOut() {
            var query = service.getODataResource().odata();
            return query
              .filter('ApplicationType/ApplicationTypeName', 'Site')
              .query()
              .$promise;
        }

        function getApplicationByShortName(shortName) {
            var url = 'application/' + encodeURIComponent(shortName);
            return coreService.httpAccountsGet(url);
        }
    }
})();
